export default {
  users: [],
  ownerList: [],
  isInitialized: false,
  isLoading: false,
  error: null,
  uid: null,
};
